import { Museum } from "@Interfaces/dddApi.interfaces";
import { LangType, TipologiaVisita, VisitorsInfoResponse } from "@Interfaces/interfaces";
import { createAction, props } from "@ngrx/store";

//* SINGLE MUSEUM
export const loadSingleMuseum = createAction(
  '[SINGLE MUSEUM API] check and load single museum if empty',
  props<{ codesr: string }>()
);
export const setSingleMuseum = createAction(
  '[SINGLE MUSEUM API] saved single museum',
  props<{ museum:Museum }>()
);
export const singleMuseumLoadError = createAction(
  '[ERROR][SINGLE MUSEUM API] error while loading single museum',
  props<{ museumLoadError:any }>()
);
export const clearSingleMuseumLoadError = createAction(
  '[CLEAR][SINGLE MUSEUM API] cleared single museum load error'
);
export const clearSingleMuseum = createAction(
  '[CLEAR][SINGLE MUSEUM API] Clear single museum'
);

//* VISIT LIST
export const loadSingleMuseumVisitList = createAction(
  '[VISIT LIST API] check and load visit list if empty',
  props<{ codesr?: string, lang: LangType }>()
);
export const setSingleMuseumVisitList = createAction(
  '[VISIT LIST API] saved visit list',
  props<{ visitsList:TipologiaVisita[] }>()
);
export const singleMuseumVisitListLoadError = createAction(
  '[ERROR][VISIT LIST API] error while loading visit list',
  props<{ visitLoadError:any }>()
);
export const clearSingleMuseumVisitListLoadError = createAction(
  '[CLEAR][VISIT LIST API] cleared visit list load error'
);
export const clearVisitList = createAction(
  '[CLEAR][VISIT LIST API] Clear visit list'
);



//* PAGINATED MUSEUMS
export const loadMuseumsByPage = createAction(
  '[MUSEUMS API] Load Museums By Page',
  props<{ page: number; pageSize: number }>()
);
export const setMuseumsForPage = createAction(
  '[MUSEUMS API] Set Museums For Page',
  props<{ page: number; museums: Museum[] }>()
);
export const museumsPaginatedLoadError = createAction(
  '[MUSEUMS API] Museums Load Error',
  props<{ error: any }>()
);
export const museumsPaginatedAlreadyLoaded = createAction(
  '[MUSEUMS API] Museums from this page already loaded'
);
export const clearPaginatedMuseums = createAction(
  '[MUSEUMS API] Clear Paginated Museums'
);

//* DONE LOADING
export const doneLoadingSingleMuseumInfos = createAction(
  '[MUSEUMS API] Done Loading Single Museum Infos'
);
export const doneLoadingSingleMuseumVisits = createAction(
  '[MUSEUMS API] Done Loading Single Museum Visits'
);

//* LANGUAGE
export const setLanguage = createAction(
  '[LANGUAGE] Set Language',
  props<{ lang: LangType }>()
);

//* VISITOR INFO
export const loadVisitorInfo = createAction(
  '[VISITOR INFO] Load Visitor Info',
  props<{ codesr: string, lang: LangType }>()
);
export const setVisitorInfo = createAction(
  '[VISITOR INFO] Set Visitor Info',
  props<{ info: VisitorsInfoResponse | null, infoLang: LangType | null, forMuseum: string | null }>()
);
